import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsSafetyRequirementType, PmsSafetyRequirementType } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsSafetyRequirementType>
    useData={usePmsSafetyRequirementType}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
